import type {
  DialogComponentProps,
  GLOBAL_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import { useEffect, useState } from 'react';
import * as styles from './index.css';
import { useInMobile } from '@affine/core/components/hooks/use-in-mobile';
import { useNavigateHelper } from '@affine/core/components/hooks/use-navigate-helper';
import { useService } from '@toeverything/infra';
import { AuthService } from '@affine/core/modules/cloud';
import { toast } from '@affine/component';
import { useI18n } from '@affine/i18n';

export const InvitationCodeDialog = ({
  onFailed,
  onSuccess,
  localStorageKey,
}: DialogComponentProps<GLOBAL_DIALOG_SCHEMA['invitation-code']>) => {
  const t = useI18n();
  const auth = useService(AuthService);
  const [isShowInvitationCode, setIsShowInvitationCode] = useState(true);
  const { inMobile } = useInMobile();
  const [invitationCode, setInvitationCode] = useState('');
  const [checkStatus, setCheckStatus] = useState('init');
  const { jumpToSignIn } = useNavigateHelper();

  //   const onClose = () => {
  //     setIsShowInvitationCode(false);
  //     jumpToSignIn();
  //   };
  const onClickReturn = () => {
    setIsShowInvitationCode(false);
    localStorage.removeItem(localStorageKey);
    jumpToSignIn();
  };

  const onClickContinue = async () => {
    if (!invitationCode || checkStatus === 'loading') {
      return;
    }
    try {
      setCheckStatus('loading');
      const inviteRes = await auth.signInOauthInvite(
        invitationCode,
        localStorageKey
      );
      if (inviteRes.data?.isActivated === 1) {
        setCheckStatus('success');
        await auth.session.account$.waitFor(account => !!account);
        setTimeout(() => {
          onSuccess();
        }, 600);
      } else {
        setCheckStatus('fail');
        toast(t['com.affine.auth.invite.error.toast']());
        onFailed();
      }
    } catch (error) {
      setCheckStatus('fail');
      onFailed();
    }
  };
  useEffect(() => {
    if (checkStatus === 'fail' && !invitationCode) {
      setCheckStatus('init');
    }
  }, [checkStatus, invitationCode]);
  return isShowInvitationCode ? (
    <div className={styles.invitation_wrapper}>
      <div
        className={`${styles.invitation_content} ${inMobile ? styles.invitation_content_mobile : ''}`}
      >
        {!inMobile && (
          <div className={styles.invitation_content_left}>
            <img
              className={styles.invitation_content_left_image}
              src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/loginImage.png"
              alt=""
            />
          </div>
        )}
        <div
          className={`${styles.invitation_content_right} ${inMobile ? styles.invitation_content_mobile_right : ''}`}
        >
          {/* <div
            className={`${styles.invitation_content_right_close} ${inMobile ? styles.invitation_content_mobile_right_close : ''}`}
          >
            <IconFont
              name="close-bold"
              className={styles.invitation_content_right_close_icon}
              onClick={onClose}
            />
          </div> */}
          <div className={styles.invitation_content_right_bottom}>
            <div className={styles.invitation_content_right_title}>
              <span className={styles.invitation_title_text}>
                {t['com.affine.auth.invite.title.first']()}
                <br />
                {t['com.affine.auth.invite.title.second']()}
              </span>
            </div>
            <div className={styles.invitation_content_right_invitation}>
              <div
                className={styles.invitation_content_right_invitation_subtitle}
              >
                {t['com.affine.auth.invite.subtitle.first']()}
                <br />
                {t['com.affine.auth.invite.subtitle.second']()}
              </div>

              <input
                className={`${styles.invitation_content_right_invitation_input} ${checkStatus === 'fail' && invitationCode ? styles.invitation_content_right_invitation_input_fail : ''}`}
                value={invitationCode}
                onChange={e => setInvitationCode(e.target.value)}
                onBlur={e => setInvitationCode(e.target.value)}
                placeholder="Enter invitation code"
              />

              <div
                className={
                  styles.invitation_content_right_invitation_button_wrapper
                }
              >
                <div
                  className={
                    styles.invitation_content_right_invitation_button_return
                  }
                  onClick={onClickReturn}
                >
                  {t['com.affine.auth.invite.return']()}
                </div>
                <div
                  className={
                    styles.invitation_content_right_invitation_button_continue
                  }
                  onClick={() => {
                    onClickContinue().catch(() => {
                      setCheckStatus('fail');
                    });
                  }}
                >
                  {t['com.affine.auth.invite.continue']()}
                </div>
              </div>
            </div>
            {checkStatus !== 'success' && (
              <div
                className={`${styles.invitation_content_right_footer} ${inMobile ? styles.invitation_content_mobile_right_footer : ''}`}
              >
                {t['com.affine.auth.invite.footer.first']()}
                <br />
                {t['com.affine.auth.invite.footer.second']()}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
